import { EAreaPartsField } from './internal/enums';

export const REQUIRED_FIELDS = [EAreaPartsField.Area, EAreaPartsField.Price, EAreaPartsField.FloorFrom];

export const VALIDATABLE_FIELDS = [
  EAreaPartsField.Area,
  EAreaPartsField.Price,
  EAreaPartsField.FloorFrom,
  EAreaPartsField.FloorTo,
];
